import React, { ReactElement } from 'react';
import { Message } from 'slovlex-idsk-react-components';
import { Heading } from 'idsk-react-components';
import { useClientStatusContext } from '../../context/ClientStatusContext';
import { ClientStatusError } from '../../model/types/ClientStatusError';
import { ClientStatus } from '../../model/types/ClientStatus';
import useScrollToErrorMessage from './hook/useScrollToErrorMessage';
import './globalErrors.scss';

const getErrorMessageKey = (error: ClientStatusError, index: number): string => (
  error.fieldName || `${error.message} - ${index}`
);

const getErrorMessageForResponseCode = (status: ClientStatus): string => {
  if (status.responseCode >= 500) {
    return 'Z technických príčin nebolo možné vykonať požadovanú akciu. Prosím, zopakujte '
      + 'požiadavku neskôr alebo kontaktujte Helpdesk Slov-Lex.';
  }
  if (status.responseCode === 403) {
    return 'Nemáte oprávnenie na vykonávanie požadovanej akcie.';
  }
  return null;
};

const GlobalErrors = (): ReactElement => {
  const { status, clearGeneralErrorMessage, clearStatus } = useClientStatusContext();
  useScrollToErrorMessage(status);
  const generalErrorMessages: ReactElement = (
    <div>
      {status && status.generalErrors.map((error, index) => (
        <Message
          className="client-error-message"
          key={getErrorMessageKey(error, index)}
          type="error"
          onClear={() => clearGeneralErrorMessage(error.message)}
        >
          <Heading
            className="client-error-message__heading"
            size="m"
          >{error.message}
          </Heading>
        </Message>
      ))}
    </div>
  );

  const unexpectedErrorMessages: ReactElement = (
    status && getErrorMessageForResponseCode(status) ? (
      <Message
        onClear={clearStatus}
        className="client-error-message"
        key="general-error"
        type="error"
      >
        <Heading
          className="client-error-message__heading"
          size="m"
        >{getErrorMessageForResponseCode(status)}
        </Heading>
      </Message>
    ) : null
  );

  return status?.generalErrors.length ? generalErrorMessages : unexpectedErrorMessages;
};

export default GlobalErrors;
